import { gql, useMutation } from '@apollo/client';
import { TerminationReasonModel } from '@utmost.co/enterprise-models';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';
import { useTerminationReasonsIntl } from '../translations/useTerminationReasonsIntl';

const DELETE_TERMINATION_REASON = gql`
  mutation deleteTerminationReason($uid: String!) {
    deleteTerminationReason(uid: $uid) {
      uid
    }
  }
`;

export function useDeleteTerminationReasons() {
  const { enqueueSnackbar, showError } = useSnackbar();
  const intl = useTerminationReasonsIntl();
  const [deleteTerminationReason, { loading }] = useMutation<
    {
      deleteTerminationReason: Pick<TerminationReasonModel, 'uid'>;
    },
    { uid: string }
  >(DELETE_TERMINATION_REASON);
  const deleteSelected = async (uid: string) => {
    try {
      await deleteTerminationReason({ variables: { uid } });
      enqueueSnackbar(intl.deleteSuccess, {
        variant: 'success'
      });
    } catch (e: any) {
      let message = e.toString();
      if (Array.isArray(e) && e?.[0]?.message) {
        message = e?.[0]?.message;
      }

      showError(message);
    }
  };
  return {
    deleteSelected,
    loading
  };
}
